import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { ControlId } from './controlCenter.types';

interface SortableControlProps {
  id: ControlId;
  children: React.ReactNode;
  colSpan: 1 | 2 | 4;
  isEditMode: boolean;
}

export const SortableControl: React.FC<SortableControlProps> = ({ id, children, colSpan, isEditMode }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
    disabled: !isEditMode,
  });

  // Use only translate (no scale) to prevent deformation
  const style: React.CSSProperties = {
    transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
    transition,
    gridColumn: `span ${colSpan}`,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`neo-cc-sortable ${isDragging ? 'dragging' : ''}`}
      {...(isEditMode ? { ...attributes, ...listeners } : {})}
    >
      {children}
    </div>
  );
};
